(function ($, Drupal) {
  Drupal.behaviors.faqSwitch = {
    attach(context, settings) {
      let maxHeight = 0;

      function matchHeight() {
        $('.js_matchHeight').find('.matchHeight').once().each(function () {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
        });

        $('.matchHeight').height(maxHeight);
      }

      $('.js_faq', context).once('faqSwitch').each(function () {
        let $el = $(this),
          $selector = $el.find('.faq__option'),
          $resPixel = $('.js_resolution');

        $selector.on('click', function () {
          const $this = $(this);

          if ($this.hasClass('is_active')) {
            if ($resPixel.css('opacity') < '0.5') {
              $this.removeClass('is_active');
            }
            $this.removeClass('is_active');
          }
          else {
            $selector.removeClass('is_active');
            $this.addClass('is_active');
            matchHeight();
          }
        });
      });

      $('.faq__term-item').once('faqQuestion').each(function () {
        let $el = $(this),
          $question = $(this).find('.faq__term-question'),
          $answer = $(this).find('.faq__term-answer');

        $el.on('click', () => {
          if ($question.hasClass('active')) {
            $question.removeClass('active');
          }
          else {
            $question.addClass('active');
          }

          $answer.slideToggle();
        });
      });
    },
  };
}(jQuery, Drupal));
